import * as Yup from 'yup';

Yup.setLocale({
  mixed: {
    required: 'Campo obrigatório',
  },
  string: {
    email: 'Preencha um e-mail válido',
    min: 'Mínimo de ${min} caracteres',
    max: 'Máximo de ${max} caracteres',
  },
  number: {
    min: 'Deve ser maior ou igual a ${min}',
    max: 'Deve ser menor ou igual a ${max}',
  },
});
const Schema = Yup.object().shape({
  name: Yup.string().required(),
  active: Yup.string().required(),
  id_scheme: Yup.string().required(),
  relation: Yup.string().required(),
});
export default Schema;